module.exports = __webpack_public_path__ + "static/media/capa.a7baf990.jpg";